import { GQLAuthentication, GQLSecurityContext } from '@jewelutions/core-crm-server-api-client-domain';
import React from 'react';

export class AuthenticationStorage {
  private static authenticationKey = 'authorization';

  static hasAuthentication(): boolean {
    return sessionStorage.getItem(AuthenticationStorage.authenticationKey) !== null;
  }

  static removeAuthentication() {
    sessionStorage.removeItem(AuthenticationStorage.authenticationKey);
  }

  static getAuthentication(): GQLAuthentication | null {
    if (sessionStorage.getItem(AuthenticationStorage.authenticationKey)) {
      return JSON.parse(
        sessionStorage.getItem(AuthenticationStorage.authenticationKey)!
      ) as GQLAuthentication;
    }
    return null;
  }

  static setAuthentication(value: GQLAuthentication) {
    sessionStorage.setItem(AuthenticationStorage.authenticationKey, JSON.stringify(value));
  }
}

interface IAuthContext {
  token: string | null;
  auth: GQLSecurityContext | null;
  setAuthentication: (auth: any) => void;
  unsetAuthentication: () => void;
  isAuthenticated: () => boolean;
}

const AuthContext = React.createContext<IAuthContext>({
  auth: AuthenticationStorage.getAuthentication()
} as IAuthContext);

const userLanguage = 'en'; // authData ? authData.userLang : 'en';

export { AuthContext, userLanguage };
